import script from "./CartItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItem.vue?vue&type=script&setup=true&lang=ts"

import "./CartItem.vue?vue&type=style&index=0&id=60bb6ae6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60bb6ae6"]])

export default __exports__